import env from './env';

export const channelTalkPluginKeys = {
  dev: '8ac8af02-5614-4f2c-8636-a85a517785aa',
  prod: 'f84740d4-cd32-4c35-805f-0f57deb99fbc',
};

export const channelTalkPluginKey =
  env === 'production' ? channelTalkPluginKeys.prod : channelTalkPluginKeys.dev;
